import { computed } from "vue";
import { i18n } from "./../../i18n";
const { t } = i18n.global;

const menuItems = computed(() => [
    {
        slug: "submissions",
        path: "/submissions",
        name: "Submissions",
        label: t("submissionshub.pages.menuItems.submissions.linkLabel"),
        children: [
            {
                path: "/submissions/vat-submissions",
                name: "VATSubmissions",
                label: t("submissionshub.pages.menuItems.submissions.children.VATSubmissions.linkLabel"),
            },
        ],
    },
]);

export { menuItems };
